/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import React from 'react';

import { useThemeClassName } from '../../../contexts/ThemeContext';

import styles from '../../../../styles/displays/banners/image.module.scss';

const propTypes = {};

const defaultProps = {};

function Image() {
    const themeClassName = useThemeClassName(styles);
    return (
        <div className={classNames([styles.container, themeClassName])}>
            <div className={styles.inner}>Large image</div>
        </div>
    );
}

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

export default Image;
